import {
    PRODUCT_LIST_REQUEST,
    PRODUCT_LIST_SUCCESS,
    PRODUCT_LIST_FAIL,
    PRODUCT_DETAILS_REQUEST,
    PRODUCT_DETAILS_SUCCESS,
    PRODUCT_DETAILS_FAIL,
    PRODUCT_DELETE_REQUEST,
    PRODUCT_DELETE_SUCCESS,
    PRODUCT_DELETE_FAIL,
    PRODUCT_CREATE_REVIEW_REQUEST,
    PRODUCT_CREATE_REVIEW_SUCCESS,
    PRODUCT_CREATE_REVIEW_FAIL,
    PRODUCT_CREATE_REQUEST,
    PRODUCT_CREATE_SUCCESS,
    PRODUCT_CREATE_FAIL,
    ARTISAN_PRODUCTS_REQUEST,
    ARTISAN_PRODUCTS_SUCCESS,
    ARTISAN_PRODUCTS_FAIL,
    ARTISAN_PRODUCTS_DETAIL_REQUEST,
    ARTISAN_PRODUCTS_DETAIL_SUCCESS,
    ARTISAN_PRODUCTS_DETAIL_FAIL,
    ARTISAN_PRODUCT_APPROVED_REQUEST,
    ARTISAN_PRODUCT_APPROVED_SUCCESS,
    ARTISAN_PRODUCT_APPROVED_FAIL,
    PRODUCT_APPROVED_REQUEST,
    PRODUCT_APPROVED_SUCCESS,
    PRODUCT_APPROVED_FAIL,
    APPROVED_PRODUCTS_REQUEST,
    APPROVED_PRODUCTS_SUCCESS,
    APPROVED_PRODUCTS_FAIL,
    PRODUCT_FILTER_REQUEST,
    PRODUCT_FILTER_SUCCESS,
    PRODUCT_FILTER_FAIL
} from '../constants/ProductConstants';
import axios from 'axios';
import { logout } from './AuthActions';
import { server_api } from './api';


export const listProducts = () => async (dispatch) => {

    try {
        dispatch({
            type: PRODUCT_LIST_REQUEST
        })

        const config = {
            headers: {
                'Content-Type': 'application/json'
            }
        }

        const { data } = await axios.get(`${server_api}/api/products`, config)

        dispatch({
            type: PRODUCT_LIST_SUCCESS,
            payload: data
        })


    } catch (error) {
        
        const resErr =  error.response && error.response.data.message ? error.response.data.message : error.message
        
        dispatch({
            type: PRODUCT_LIST_FAIL,
            payload: resErr
        })
    }
}

export const getApprovedProducts = () => async (dispatch) => {

    try {
        dispatch({
            type: APPROVED_PRODUCTS_REQUEST
        })

        const config = {
            headers: {
                'Content-Type': 'application/json'
            }
        }

        const { data } = await axios.get(`${server_api}/api/products/approved`, config)

        dispatch({
            type: APPROVED_PRODUCTS_SUCCESS,
            payload: data
        })


    } catch (error) {

        const resErr = error.response && error.response.data.message ? error.response.data.message : error.message

        dispatch({
            type: APPROVED_PRODUCTS_FAIL,
            payload: resErr
        })
    }
}


export const getProductDetails = (id) => async (dispatch) => {

    try {
        
        dispatch({
            type: PRODUCT_DETAILS_REQUEST
        })

        const config = {
            headers: {
                'Content-Type': 'application/json'
            }
        }

        const { data } = await axios.get(`${server_api}/api/products/${id}`, config)

        dispatch({
            type: PRODUCT_DETAILS_SUCCESS,
            payload: data
        })

    } catch (error) {
       
        const resErr =  error.response && error.response.data.message ? error.response.data.message : error.message
        
        dispatch({
            type: PRODUCT_DETAILS_FAIL,
            payload: resErr
        })
    }
}



export const deleteProduct = (id) => async (dispatch, getState) => {

    try {
        
        dispatch({
            type: PRODUCT_DELETE_REQUEST
        })

        const { authLogin: { info } } = getState()

        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization : `Bearer ${info.token}`
            }
        }


        await axios.delete(`${server_api}/api/products/${id}`, config)

        dispatch({
            type: PRODUCT_DELETE_SUCCESS
        })


    } catch (error) {
        const message = error.response && error.response.data.message
        ? error.response.data.message
        : error.message

        if (message === 'Not authorized, token failed') {
            dispatch(logout())
        }

        dispatch({
            type: PRODUCT_DELETE_FAIL,
            payload: message,
        })
    }
    
}




export const createProductReview = (productId, review) => async (dispatch, getState) => {

    try {
        
        dispatch({
            type: PRODUCT_CREATE_REVIEW_REQUEST,
        })
    
        const { authLogin: { info } } = getState()

        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization : `Bearer ${info.token}`
            }
        }
    
        await axios.post(`${server_api}/api/products/${productId}/reviews`, review, config)
    
        dispatch({
            type: PRODUCT_CREATE_REVIEW_SUCCESS,
        })

    } catch (error) {

        const message =
            error.response && error.response.data.message
            ? error.response.data.message
            : error.message

        if (message === 'Not authorized, token failed') {
            dispatch(logout())
        }

        dispatch({
            type: PRODUCT_CREATE_REVIEW_FAIL,
            payload: message,
        })
    }
}




export const createProduct = (productData) => async (dispatch, getState) => {

    try {

        dispatch({
            type: PRODUCT_CREATE_REQUEST,
        })

        const { authLogin: { info } } = getState()

        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${info.token}`
            }
        }

        await axios.post(`${server_api}/api/products`, productData, config)

        dispatch({
            type: PRODUCT_CREATE_SUCCESS,
        })

    } catch (error) {

        const message =
            error.response && error.response.data.message
                ? error.response.data.message
                : error.message

        if (message === 'Not authorized, token failed') {
            dispatch(logout())
        }

        dispatch({
            type: PRODUCT_CREATE_FAIL,
            payload: message,
        })
    }
}


export const artisanListProducts = () => async (dispatch, getState) => {

    try {
        dispatch({
            type: ARTISAN_PRODUCTS_REQUEST
        })

        const { authLogin: { info } } = getState();

        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${info.token}`
            }
        }

        const { data } = await axios.get(`${server_api}/api/products/artisan`, config)

        dispatch({
            type: ARTISAN_PRODUCTS_SUCCESS,
            payload: data
        })


    } catch (error) {

        const resErr = error.response && error.response.data.message ? error.response.data.message : error.message

        dispatch({
            type: ARTISAN_PRODUCTS_FAIL,
            payload: resErr
        })
    }
}



export const artisanGetProductDetails = (id) => async (dispatch, getState) => {

    try {

        dispatch({
            type: ARTISAN_PRODUCTS_DETAIL_REQUEST
        })

        const { authLogin: { info } } = getState();

        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${info.token}`
            }
        }

        const { data } = await axios.get(`${server_api}/api/products/artisan/${id}`, config)

        dispatch({
            type: ARTISAN_PRODUCTS_DETAIL_SUCCESS,
            payload: data
        })

    } catch (error) {

        const resErr = error.response && error.response.data.message ? error.response.data.message : error.message

        dispatch({
            type: ARTISAN_PRODUCTS_DETAIL_FAIL,
            payload: resErr
        })
    }
}



export const artisanProductApprovedAction = (id, approvedData) => async (dispatch, getState) => {

    try {

        dispatch({
            type: ARTISAN_PRODUCT_APPROVED_REQUEST
        })

        const { authLogin: { info } } = getState();

        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${info.token}`
            }
        }

        await axios.put(`${server_api}/api/products/artisan/approved/${id}`, approvedData, config)

        dispatch({
            type: ARTISAN_PRODUCT_APPROVED_SUCCESS,
        })

    } catch (error) {

        const resErr = error.response && error.response.data.message ? error.response.data.message : error.message

        dispatch({
            type: ARTISAN_PRODUCT_APPROVED_FAIL,
            payload: resErr
        })
    }
}




export const productApprovedAction = (id, approvedData) => async (dispatch, getState) => {

    try {

        dispatch({
            type: PRODUCT_APPROVED_REQUEST
        })

        const { authLogin: { info } } = getState();

        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${info.token}`
            }
        }

        await axios.put(`${server_api}/api/products/approved/${id}`, approvedData, config)

        dispatch({
            type: PRODUCT_APPROVED_SUCCESS,
        })

    } catch (error) {

        const resErr = error.response && error.response.data.message ? error.response.data.message : error.message

        dispatch({
            type: PRODUCT_APPROVED_FAIL,
            payload: resErr
        })
    }
}




export const getProductFilters = () => async (dispatch) => {

    try {
        dispatch({
            type: PRODUCT_FILTER_REQUEST
        })

        const config = {
            headers: {
                'Content-Type': 'application/json'
            }
        }

        const { data } = await axios.get(`${server_api}/api/products/filter`, config)

        dispatch({
            type: PRODUCT_FILTER_SUCCESS,
            payload: data
        })


    } catch (error) {

        const resErr = error.response && error.response.data.message ? error.response.data.message : error.message

        dispatch({
            type: PRODUCT_FILTER_FAIL,
            payload: resErr
        })
    }
}